import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TriyoButton, PrimaryButton } from '../../../../components/TriyoButton';
import CreateField from "./create-field";
import './field-repository.scss';
import { GetDynamicFieldRepository } from "../../../../services/api/dynamic-fields-api";
import EditField from "./edit-field";
import MemberIconNew from "../../../../components/member-icon-new/member-icon-new";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux/user/user-selector";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";

const FieldRepositoryTable = () => {

    const [fields, setFields] = useState([]);
    const [showCreateFieldModal, setShowCreateFieldModal] = useState(false);
    const [selectedField, setSelectedField] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const user = useSelector(selectUser);
    const { privileges } = user;
    const canCreate = privileges["Field Repository"]?.Add;
    const canEdit = privileges["Field Repository"]?.Edit;
    const canViewDetails = privileges["Field Repository"]?.Detail;

    useEffect(() => {
        GetFieldRepository();
    }, []);

    const onHide = () => {
        setShowCreateFieldModal(false);
        setSelectedField(false);
        setIsEdit(false);
    }

    const GetFieldRepository = () => {
        GetDynamicFieldRepository()
            .then((res) => {
                if (res.status === 200) {
                    setFields(res.data);
                }
            })
            .catch((err) => {
                console.log("Error [GetAllWorkflows] => ", err);
            });
    }

    return (
        <div className="admin-task-types-table-wrapper fieldRepository">
            <div className="admin-panel-table-container">
                <div className="table-control-container">
                    <TriyoButton>
                        { canCreate ? (
                            <PrimaryButton
                                onClick={() => setShowCreateFieldModal(true)}
                                text="Create New Field" 
                                disabled={!canCreate}
                            />
                        ):(
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>You do not have the requisite Role Privileges to Add Field Objects on TRIYO.</Tooltip>}
                            >
                                <span>
                                    <PrimaryButton
                                        onClick={() => setShowCreateFieldModal(true)}
                                        text="Create New Field" 
                                        disabled={!canCreate}
                                    />
                                </span>
                            </OverlayTrigger>
                        )}
                    </TriyoButton>
                </div>
                {
                    canViewDetails ?
                    <div className="field-repo-container">
                        <table className="table-element">
                            <thead className="sticky-header">
                                <tr >
                                    <th className="th-repo-col">FIELD ID</th>
                                    <th className="th-repo-col">DEFAULT FIELD LABEL</th>
                                    <th className="th-repo-col">FIELD TYPE</th>
                                    <th className="th-repo-col">DESCRIPTION</th>
                                    <th className="th-repo-col">API NAME</th>
                                    <th className="th-repo-col">CREATED BY</th>
                                    <th className="th-repo-col">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields.map((field, index) => {
                                    return (
                                    <tr key={field.Id} className={`template-row-1 field-repo-row`} onClick={() => setSelectedField(field)}>
                                        <td className="data-text template-name" >{field.Id}</td>
                                        <td className="data-text template-name" >{field.Label}</td>
                                        <td className="data-text template-name" >{field.FieldType}</td>
                                        <td className="data-text template-name" >{field.Description}</td>
                                        <td className="data-text template-name" >{field.APIName}</td>
                                        <td className="data-text template-name" >
                                            {
                                                field.AddedByUser &&
                                                <div className="d-flex align-items-center">
                                                    <MemberIconNew
                                                        type={'user'}
                                                        member={field.AddedByUser}
                                                        extraMembers={0}
                                                        isGroup={false}
                                                    ></MemberIconNew>
                                                    <span className="ml-2">{field?.AddedByUser?.Name}</span>
                                                </div>
                                            }


                                            </td>
                                            <td className="admin-row-action-buttons">
                                                <div style={{width: '40px'}}>
                                                <FluentButton
                                                    className={`btn-icon1`}
                                                    appearance="subtle"
                                                    icon={<FluentUiIcon name={canEdit ? "EditRegular" : "EyeRegular"} size={18} color={'#0F6CBD'}/>}

                                                    onClick={() => {
                                                        setIsEdit(canEdit);
                                                        setSelectedField(field);
                                                    }}
                                                    title={canEdit ? "Edit" : "View"}
                                                />
                                                </div>
                                                {/* {field.Deleted ? <Button
                                                    className={`btn-icon1 unarchive-icon`}
                                                    // onClick={() => setShowUnArchiveModal(field)}
                                                    title="Un-Archive"
                                                ></Button>
                                                    :
                                                    <Button
                                                        className={`btn-icon1 archive-icon2`}
                                                        // onClick={() => setShowArchiveModal(field)}
                                                        title="Archive"
                                                    ></Button>} */}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    : <NoPermissionTable />
                } 
            </div>

            {showCreateFieldModal && <CreateField show={showCreateFieldModal} onHide={onHide} GetFieldRepository={GetFieldRepository} />}
            {selectedField && <EditField isEdit={isEdit} setIsEdit={setIsEdit} show={selectedField} onHide={onHide} selectedField={selectedField} GetFieldRepository={GetFieldRepository} canEdit={canEdit} />}
        </div>
    );
}

export default FieldRepositoryTable;